"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPolicyByNameReset = exports.getPolicyByNameFailure = exports.getPolicyByNameSuccess = exports.getPolicyByNameLoading = exports.getPolicyByNameRequest = exports.getPolicyByIdReset = exports.getPolicyByIdFailure = exports.getPolicyByIdSuccess = exports.getPolicyByIdLoading = exports.getPolicyByIdRequest = exports.approvalNotificationMediumDetailsSuccess = exports.approvalNotificationMediumDetailsFailure = exports.approvalNotificationMediumDetailsReset = exports.approvalNotificationMediumDetailsLoading = exports.approvalNotificationMediumDetailsRequest = void 0;

var _constants = require("./constants");

var approvalNotificationMediumDetailsRequest = function approvalNotificationMediumDetailsRequest(_ref) {
  var channelId = _ref.channelId,
      history = _ref.history;
  return {
    type: _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_REQUEST,
    payload: {
      channelId: channelId,
      history: history
    }
  };
};

exports.approvalNotificationMediumDetailsRequest = approvalNotificationMediumDetailsRequest;

var approvalNotificationMediumDetailsLoading = function approvalNotificationMediumDetailsLoading() {
  return {
    type: _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_LOADING
  };
};

exports.approvalNotificationMediumDetailsLoading = approvalNotificationMediumDetailsLoading;

var approvalNotificationMediumDetailsReset = function approvalNotificationMediumDetailsReset() {
  return {
    type: _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_RESET
  };
};

exports.approvalNotificationMediumDetailsReset = approvalNotificationMediumDetailsReset;

var approvalNotificationMediumDetailsFailure = function approvalNotificationMediumDetailsFailure(payload) {
  return {
    type: _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_FAILURE,
    payload: payload
  };
};

exports.approvalNotificationMediumDetailsFailure = approvalNotificationMediumDetailsFailure;

var approvalNotificationMediumDetailsSuccess = function approvalNotificationMediumDetailsSuccess(payload) {
  return {
    type: _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_SUCCESS,
    payload: payload
  };
};

exports.approvalNotificationMediumDetailsSuccess = approvalNotificationMediumDetailsSuccess;

var getPolicyByIdRequest = function getPolicyByIdRequest(payload) {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_REQUEST,
    payload: payload
  };
};

exports.getPolicyByIdRequest = getPolicyByIdRequest;

var getPolicyByIdLoading = function getPolicyByIdLoading() {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_LOADING
  };
};

exports.getPolicyByIdLoading = getPolicyByIdLoading;

var getPolicyByIdSuccess = function getPolicyByIdSuccess(policyViewData) {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_SUCCESS,
    payload: policyViewData
  };
};

exports.getPolicyByIdSuccess = getPolicyByIdSuccess;

var getPolicyByIdFailure = function getPolicyByIdFailure(reason) {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_FAILURE,
    payload: reason
  };
};

exports.getPolicyByIdFailure = getPolicyByIdFailure;

var getPolicyByIdReset = function getPolicyByIdReset() {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_RESET
  };
};

exports.getPolicyByIdReset = getPolicyByIdReset;

var getPolicyByNameRequest = function getPolicyByNameRequest(payload) {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_REQUEST,
    payload: payload
  };
};

exports.getPolicyByNameRequest = getPolicyByNameRequest;

var getPolicyByNameLoading = function getPolicyByNameLoading() {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_LOADING
  };
};

exports.getPolicyByNameLoading = getPolicyByNameLoading;

var getPolicyByNameSuccess = function getPolicyByNameSuccess(policyViewData) {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_SUCCESS,
    payload: policyViewData
  };
};

exports.getPolicyByNameSuccess = getPolicyByNameSuccess;

var getPolicyByNameFailure = function getPolicyByNameFailure(reason) {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_FAILURE,
    payload: reason
  };
};

exports.getPolicyByNameFailure = getPolicyByNameFailure;

var getPolicyByNameReset = function getPolicyByNameReset() {
  return {
    type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_RESET
  };
};

exports.getPolicyByNameReset = getPolicyByNameReset;